import * as React from "react";
import { Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import type { ButtonProps } from 'antd';

interface CustomButtonProps {
    saving?: boolean,
    primary?: boolean,
    secondary?: boolean,
    disabled?: boolean,
    size?: ButtonProps['size']
    text: string,
    savingText?: string,
    icon?: React.ReactNode,
    labelPosition?: 'right' | 'left',
    visible?: boolean,
    onClick: (event: React.SyntheticEvent) => void
}

const CustomButton = (props: CustomButtonProps) => {
    const disable = () => {
        if(props.saving === true)
            return true;

        return props.disabled;
    }
    
    const content = () => {
        return (props.savingText && props.saving === true) ? props.savingText : props.text
    }

    const renderIcon = () => {
        if(props.saving === true) {
            return <LoadingOutlined />;
        }
        return props.icon || undefined;
    }

    if (props.visible !== undefined && props.visible === false) {
        return <></>;
    }

    const iconElement = renderIcon();

    return <Button
            type={props.primary ? "primary" : props.secondary ? "default" : "default"}
            size={props.size}
            disabled={disable()}
            icon={props.labelPosition === 'right' || !props.labelPosition ? iconElement : undefined}
            loading={props.saving}
            onClick={props.onClick}>
            {content()}
        </Button>;
}

export default CustomButton;